/** Direction embedded in admin rich-text / block formatting (not UI locale). */

const RTL_SCRIPT =  /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
const LATIN_LETTER = /[A-Za-z]/;

function htmlIndicatesRtl(html: string): boolean {
  if (html.includes('data-align="justify-right"')) return true;
  if (html.includes('data-direction="rtl"')) return true;
  if (/\bdir="rtl"/i.test(html)) return true;
  if (/direction\s*:\s*rtl/i.test(html)) return true;
  return false;
}

function htmlIndicatesLtr(html: string): boolean {
  if (html.includes('data-direction="ltr"')) return true;
  if (/direction\s*:\s*ltr/i.test(html) && !html.includes('data-direction="rtl"')) {
    return true;
  }
  return false;
}

function stripHtmlTags(value: string): string {
  return value.replace(/<[^>]+>/g, ' ');
}

function isPredominantlyRtlScript(text: string): boolean {
  const sample = text.replace(/\s+/g, '');
  if (!sample) return false;

  let rtl = 0;
  let latin = 0;
  for (const ch of sample) {
    if (RTL_SCRIPT.test(ch)) rtl += 1;
    else if (LATIN_LETTER.test(ch)) latin += 1;
  }
  if (rtl === 0) return false;
  return rtl >= latin;
}

function collectHtmlSources(
  formatting: unknown,
  textContent?: string | null
): string[] {
  const sources: string[] = [];
  if (formatting) {
    try {
      const config =
        typeof formatting === 'string'
          ? JSON.parse(formatting)
          : (formatting as { formattedContent?: string });
      if (typeof config?.formattedContent === 'string') {
        sources.push(config.formattedContent);
      }
    } catch {
      /* ignore malformed JSON */
    }
  }
  if (textContent) sources.push(textContent);
  return sources;
}

export function extractFormattedTextDirection(
  formatting: unknown,
  textContent?: string | null
): 'rtl' | 'ltr' | undefined {
  const htmlSources = collectHtmlSources(formatting, textContent);
  const combinedHtml = htmlSources.join('\n');

  if (combinedHtml && htmlIndicatesRtl(combinedHtml)) return 'rtl';
  if (combinedHtml && htmlIndicatesLtr(combinedHtml)) return 'ltr';

  const plain = htmlSources.map(stripHtmlTags).join(' ').trim() || (textContent ?? '').trim();
  if (plain && isPredominantlyRtlScript(plain)) return 'rtl';

  return undefined;
}
